import authAPI from '@/api/authAPI'

const state = {
  loggedIn: false,
  user: {},
  expirationTime: 0,
}

const mutations = {
  success(state, data){
    state.user = data.user
    state.expirationTime = data.expiration
    state.loggedIn = true
  },
  logout(state) {
    state.status = ''
    state.user = {}
    state.loggedIn = false
    state.expirationTime = 0
  },
  expiration_update(state, data) {
    state.expirationTime = data.expiration
    state.user = data.user
  },
  update_profile_info(state, data) {
    state.user.first_name = data.first_name
    state.user.middle_name = data.middle_name
    state.user.last_name = data.last_name
    state.user.phone_number = data.phone_number
  },
  update_profile_picture(state, image) {
    state.user.image = image
  }
}

const actions = {

  login({commit}, loginData) {
    return new Promise((resolve, reject) => {
      authAPI.login(loginData)
        .then(response => {
          if(response.data.message === 'success') commit('success', response.data)
          resolve(response)
        })
        .catch(error => reject(error))
    })
  },

  async validate({state, dispatch}){
    if(state.loggedIn) {
      dispatch('refresh')
      return true;
    }
    return await dispatch('isLoggedIn')
  },

  isLoggedIn({commit}){
    return authAPI.isLoggedIn().then(({ data }) => {
      if (data.isValid) {commit('success', data)}
      return data.isValid
    }).catch(() => {return false})
  },

  refresh({commit, state}){
    let timestamp = Math.floor(new Date().getTime() / 1000)
    let tokenExpiration = state.expirationTime;
    if((timestamp + 3600) > tokenExpiration) {
      authAPI.refreshToken()
        .then(({data}) => {commit('expiration_update', data)})
    }
  },

  logout({commit}){
    return new Promise((resolve, reject) => {
      authAPI.logout()
        .then(response => {
          location.reload()
          commit('logout')
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

const getters = {
  user(state) {
    return state.user;
  },
  hasRole: state => role => {
    return state.user.roles && state.user.roles.some(r => role.indexOf(r.name.toLowerCase()) !== -1 && r.pivot.status == 1)
  },
  roles(state){
    return state.user.roles.map(role => {return role.name.toLowerCase()}).reverse()
  }
}

export default({
  namespaced: true,
  state,
  getters,
  actions,
  mutations
});
